import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getMetaTracking, isMetaSuppressed, pendingWixCheckout, observeWixTrial } from '../utils/metaTracking';
export default function MetaTracking() {
  const { pathname } = useLocation();
  // Unmounting also stops an existing tracker and billing poll on SPA navigation.
  if (isMetaSuppressed(pathname)) return null;
  return <ActiveMetaTracking />;
}
function ActiveMetaTracking() {
  const { pathname: path } = useLocation();
  useEffect(() => {
    let busy = false, stopped = false;
    const poll = async () => {
      if (busy || document.visibilityState === 'hidden') return;
      const intent = pendingWixCheckout();
      if (!intent) return;
      busy = true;
      try {
        if (!localStorage.getItem('token')) return;
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}bot?bot_id=${encodeURIComponent(intent.botId)}&include_plan=true`);
        if (response.ok && !stopped) observeWixTrial(await response.json());
      } catch { /* measurement failure never affects billing */ }
      finally { busy = false; }
    };
    const timer = window.setInterval(() => {
      const intent = pendingWixCheckout();
      // Poll briefly around checkout. A later focus/remount can still recover for 24h.
      if (intent && Date.now() - intent.startedAt < 15 * 60000) poll();
    }, 15000);
    window.addEventListener('focus', poll);
    window.addEventListener('ub-meta-checkout', poll);
    poll();
    return () => { stopped = true; window.clearInterval(timer); window.removeEventListener('focus', poll); window.removeEventListener('ub-meta-checkout', poll); };
  }, []);

  const tracker = getMetaTracking();
  useEffect(() => tracker?.start(), [tracker]);
  useEffect(() => { tracker?.page(path); }, [tracker, path]);
  return null;
}
